import styled, { css, keyframes } from 'styled-components';

interface Props {
  width: number;
  height: number;
  marginBotton: number;
}

const placeholderShimmer = keyframes`
  from {
    background-position: -468px 0;
  }
  to {
    background-position: 468px 0;
  }
`;

const styles = css`
  display: block;
  max-width: 100%;
  box-sizing: border-box;
  background: #F0F4F8;
  background-image: linear-gradient(to right, #F0F4F8 0%, #F9FAFC 20%, #F0F4F8 40%, #F0F4F8 100%);
  background-repeat: no-repeat;
  background-size: 800px 100%;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeholderShimmer};
  animation-timing-function: linear;
  width: ${(props: Props) => props.width
    ?`${props.width}px`
    :'100%'};
  height: ${(props: Props) => props.height
    ?`${props.height}px`
    :'30px'};
  margin-bottom: ${(props: Props) => props.marginBotton && `${props.marginBotton}px`};
`;

export const Line = styled.div`
  ${styles}
  border-radius: 8px;
`;

export const HeaderLine = styled.div`
  ${styles}
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
`;

export const Circle = styled.div`
  ${styles}
  border-radius: 50%;
  margin-right: 8px;
`;
